import React from 'react';
import { useTranslation } from 'react-i18next';

import useClassy from '@core/hooks/useClassy';

import classes from './TypingIndicator.module.scss';

interface TypingIndicatorProps {
  show?: boolean;
}

export default function TypingIndicator({ show = true }: TypingIndicatorProps) {
  const bem = useClassy(classes, 'TypingIndicator');
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className={bem('&', 'owlbot-typing-indicator')}>
      <div className={bem('-generatingText')}>
        {t('owlbotChat.typingLabel')}
        <div className={bem('-generatingDotsWrapper')}>
          <div className={bem('-generatingDots')}>.</div>
          <div className={bem('-generatingDots')}>.</div>
          <div className={bem('-generatingDots')}>.</div>
        </div>
      </div>
    </div>
  );
}
